export enum AxisLockMode {
	XY = "XY",     // Lock to XY plane (front view)
	XZ = "XZ",     // Lock to XZ plane (top view)
	YZ = "YZ"      // Lock to YZ plane (side view)
}
